import { create } from 'zustand';

interface ScrollState {
  /** 0-1 progress through the hero section */
  heroProgress: number;
  /** 0-1 progress through the psychology/synapse section */
  psychProgress: number;
  setHeroProgress: (value: number) => void;
  setPsychProgress: (value: number) => void;
}

export const useScrollStore = create<ScrollState>()((set) => ({
  heroProgress: 0,
  psychProgress: 0,
  setHeroProgress: (value) => set({ heroProgress: value }),
  setPsychProgress: (value) => set({ psychProgress: value }),
}));
